import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Tabs, Tab } from '@material-ui/core';
import FormatUtils from '../common/formatUtils/FormatUtils';
import './pedidoLimitePetroshowModal.css';

const texto = valor => valor === null || valor === undefined || valor === '' ? '—' : valor;
const moeda = valor => valor === null || valor === undefined ? '—' : `R$ ${FormatUtils.formatarValorTelaDecimal(valor, 2)}`;
const data = valor => valor ? String(valor).slice(0, 10).split('-').reverse().join('/') : '—';
const camposFinanceiros = [
	['limite', 'Limite'], ['valorAprovado', 'Valor aprovado'], ['valorBloqueado', 'Valor bloqueado'],
	['totalDuplicatasPendentes', 'Duplicatas pendentes'], ['duplicatasVencidas', 'Duplicatas vencidas'],
	['duplicatasAVencer', 'Duplicatas a vencer'], ['chequesPendentes', 'Cheques pendentes'],
	['chequesDevolvidos', 'Cheques devolvidos']
];

function Dados({ campos }) {
	return <dl className='petroshow-dados'>
		{campos.map(([label, valor, classe]) => <div className='petroshow-campo' key={label}>
			<dt>{label}</dt><dd className={classe}>{texto(valor)}</dd>
		</div>)}
	</dl>;
}

function Bloco({ titulo, children }) {
	return <section className='petroshow-bloco'><h5>{titulo}</h5>{children}</section>;
}

function ResumoFinanceiro({ limite, dados }) {
	const saldo = limite.saldoDisponivel != null ? limite.saldoDisponivel : dados.saldoDisponivel;
	return <Bloco titulo='Resumo financeiro'>
		<Dados campos={[
			['Limite', moeda(limite.valorLimite != null ? limite.valorLimite : dados.limite)],
			['Débitos', moeda(dados.debitos)], ['Saldo em conta pessoal', moeda(dados.saldoEmContaPessoal)],
			['(-) Saldo utilizado', moeda(limite.saldoUtilizado != null ? limite.saldoUtilizado : dados.saldoUtilizado)],
			['(=) Saldo disponível', moeda(saldo), saldo == null ? '' : Number(saldo) < 0 ? 'petroshow-saldo text-danger' : 'petroshow-saldo text-success']
		]} />
	</Bloco>;
}

function Totais({ titulo, totais }) {
	if (!totais) return null;
	return <Bloco titulo={titulo}>
		<Dados campos={[
			...camposFinanceiros.map(([chave, label]) => [label, moeda(totais[chave])]),
			['Índice de pontualidade', totais.indicePontualidade == null ? '—' : `${FormatUtils.formatarValorTelaDecimal(totais.indicePontualidade, 2)}%`],
			['Duplicatas quitadas', totais.nroDuplicatasQuitadas],
			['Duplicatas quitadas no prazo', totais.nroDuplicatasQuitadasNoPrazo],
			['Carência (dias)', totais.carencia]
		]} />
	</Bloco>;
}

function Duplicatas({ titulo, lista = [], vencidas = false }) {
	return <section className='mb-4'>
		<h5>{titulo} ({lista.length})</h5>
		{lista.length === 0 ? <p className='text-muted'>Nenhuma duplicata nesta situação.</p> :
			<div className='table-responsive'>
				<table className='table table-bordered table-striped table-sm'>
					<thead><tr>
						<th>Duplicata / Empresa</th><th>Emissão</th><th>Vencimento</th>
						<th>Total</th><th>Recebido</th><th>A receber</th>{vencidas && <th>Dias de atraso</th>}
						<th>Cobrança</th>
					</tr></thead>
					<tbody>{lista.map((dup, index) => <tr key={`${dup.estab}-${dup.idDupRec}-${index}`}>
						<td>{texto(dup.dupRec || dup.duprec)}<small className='d-block'>{texto(dup.razaosoc)}</small><small className='d-block'>Estab.: {texto(dup.estab)}</small></td>
						<td style={{ whiteSpace: 'nowrap' }}>{data(dup.dtEmissao)}</td>
						<td style={{ whiteSpace: 'nowrap' }}>{data(dup.dtVencto)}</td>
						<td style={{ whiteSpace: 'nowrap' }}>{moeda(dup.vlrTotal)}</td>
						<td style={{ whiteSpace: 'nowrap' }}>{moeda(dup.vlrRecebido)}</td>
						<td style={{ whiteSpace: 'nowrap' }}>{moeda(dup.vlrAReceber != null ? dup.vlrAReceber : dup.vlrTotal != null && dup.vlrRecebido != null ? Number(dup.vlrTotal) - Number(dup.vlrRecebido) : null)}</td>
						{vencidas && <td className='text-danger'>{texto(dup.diasAtraso)}</td>}
						<td style={{ minWidth: 240, overflowWrap: 'anywhere' }}>
							<div>{texto(dup.descSituacao)}</div><div>{texto(dup.descricao)}</div>
							<div>{texto(dup.historico)}</div><div>Nosso número: {texto(dup.nossoNumero)}</div>
							<div>Linha digitável: {texto(dup.linhaDigitavel)}</div>
						</td>
					</tr>)}</tbody>
				</table>
			</div>}
	</section>;
}

function PainelAba({ aba, indice, children }) {
	return <div role='tabpanel' hidden={aba !== indice}
		id={`limite-petroshow-painel-${indice}`} aria-labelledby={`limite-petroshow-aba-${indice}`}>
		{aba === indice && children}
	</div>;
}

export default function PedidoLimitePetroshowModal({ limite, onClose }) {
	const [aba, setAba] = useState(1);
	useEffect(() => { setAba(1); }, [limite]);
	if (!limite) return null;
	const documento = limite.pessoaDoc || {};
	const pessoa = documento.pessoa || {};
	const dados = limite.dadosPessoa || {};
	const representante = (limite.representante || {}).pessoa || {};
	const cpfCnpj = String(pessoa.cnpjCpf || '');
	return <Dialog open onClose={onClose} fullWidth maxWidth='lg' aria-labelledby='limite-petroshow-titulo'
		PaperProps={{ className: 'petroshow-modal' }}>
		<DialogTitle id='limite-petroshow-titulo'>Detalhes do limite Petroshow
			<small className='petroshow-cliente'>{texto(pessoa.nome || documento.nomePessoa)}</small>
		</DialogTitle>
		<Tabs value={aba} onChange={(event, novaAba) => setAba(novaAba)}
			variant='scrollable' scrollButtons='auto' indicatorColor='primary' textColor='primary'
			aria-label='Informações do limite Petroshow'>
			{['Cliente', 'Financeiro', `Duplicatas a receber (${(limite.listaDuplicatasReceber || []).length})`,
				`Duplicatas vencidas (${(limite.listaDuplicatasVencidas || []).length})`, 'Endereços'].map((label, indice) =>
				<Tab key={indice} label={label} id={`limite-petroshow-aba-${indice}`}
					aria-controls={`limite-petroshow-painel-${indice}`} />)}
		</Tabs>
		<DialogContent dividers key={aba} className='petroshow-conteudo'>
			<PainelAba aba={aba} indice={0}>
			<div className='petroshow-colunas petroshow-colunas-cliente'>
			<Bloco titulo='Dados cadastrais'>
				<Dados campos={[
					['Nome', pessoa.nome || documento.nomePessoa], ['Código Petroshow', limite.id_cliente_petroshow || documento.idPess],
					['CPF / CNPJ', cpfCnpj.length === 14 ? FormatUtils.formatarCNPJ(cpfCnpj) : FormatUtils.formatarCPF(cpfCnpj)],
					['Nome fantasia', documento.fantasia], ['Inscrição estadual', documento.inscricaoEstadual],
					['Agente comercial', representante.nome],
					['Rota', documento.rota ? documento.rota.descricao || documento.rota.nome : 'Sem informação'],
					['Grupo econômico', documento.pessoaGrupo ? documento.pessoaGrupo.descricao || documento.pessoaGrupo.nome : 'Pessoa não possui grupo'],
					['Prazo médio', documento.prazoMedio], ['Observação', documento.observacao]
				]} />
			</Bloco>
			<Bloco titulo='Contato e informações gerais'>
				<Dados campos={[
					['E-mail', documento.email], ['Telefone', dados.telefone], ['Celular', dados.celular],
					['Fax', dados.fax], ['Tipo de pessoa', (documento.tipoPessoa || {}).descricao],
					['Observações gerais (Pedidos)', documento.observacaoGeral]
				]} />
			</Bloco>
			</div>
			</PainelAba>
			<PainelAba aba={aba} indice={1}>
			<div className='petroshow-colunas'>
			<ResumoFinanceiro limite={limite} dados={dados} />
			<Totais titulo='Totais do cliente' totais={dados.totaisPessoa} />
			<Totais titulo='Totais do grupo' totais={dados.totaisGrupo} />
			</div>
			</PainelAba>
			<PainelAba aba={aba} indice={2}>
			<Duplicatas titulo='Duplicatas a receber' lista={limite.listaDuplicatasReceber || []} />
			</PainelAba>
			<PainelAba aba={aba} indice={3}>
			<Duplicatas titulo='Duplicatas vencidas' lista={limite.listaDuplicatasVencidas || []} vencidas />
			</PainelAba>
			<PainelAba aba={aba} indice={4}>
			<section>
				<h5>Endereços</h5>
				{!(dados.enderecos || []).length && <p className='text-muted'>Nenhum endereço informado.</p>}
				<div className='petroshow-colunas petroshow-enderecos'>
				{(dados.enderecos || []).map((item, index) => {
					const endereco = item.endereco || {};
					const cidade = endereco.cidade || {};
					return <Bloco titulo={`${item.tipoEndereco === 'P' ? 'Principal' : 'Alternativo'}${item.inativo === 'S' ? ' (inativo)' : ''}`} key={`${endereco.id}-${index}`}>
						<Dados campos={[
							['Endereço', endereco.descricaoCompleta || [endereco.endereco, endereco.numero, endereco.bairro, cidade.nome, (cidade.estado || {}).uf].filter(Boolean).join(', ')],
							['Complemento', endereco.complemento], ['CEP', FormatUtils.formatarCEP(endereco.cep)],
							['Telefone', endereco.telefone], ['Celular', endereco.celular], ['Referência', endereco.referencia]
						]} />
					</Bloco>;
				})}
				</div>
			</section>
			</PainelAba>
		</DialogContent>
		<DialogActions><button type='button' className='btn btn-secondary' onClick={onClose}>Fechar</button></DialogActions>
	</Dialog>;
}
